import React from 'react';

interface DataCellProps {
    className?: string;
    label?: string | React.ReactNode;
    value?: string;
    color?: string;
}

export default function DataCell({ className, label, value, color }: DataCellProps) {

    const labelBasis = value ? 'basis-3/5' : 'basis-full';
    const valueBasis = label ? 'basis-1/5' : 'basis-full';;
    const valueDisplay = !isNaN(Number(value)) ? Number(value).toFixed(2).replace(/\.00$/, '') : value;

    return (
        <div className={`border-b border-b-neutral-300 dark:border-b-neutral-700 py-1 overflow-x-hidden ${className}`}>
            <div className='flex flex-row gap-2 p-1 px-2'>
            {color && <div className='flex-none w-3 h-3 mt-1 rounded-sm' style={{ backgroundColor: color }}></div>}
            {label && <div className={`flex-none ${labelBasis} text-sm font-semibold`}>{label}</div>}
            <div className={`flex-none ${valueBasis} text-sm`}><p>{valueDisplay}</p></div>
            </div>
        </div>
    )
}
